// api/salesPlatformApi.js
import { apiRequest } from '@/api'

export const salesPlatformApi = {
  /**
   * 获取销售平台列表
   */
  getList() {
    return apiRequest('/api/sales-platforms')
  },

  /**
   * 创建销售平台
   * @param {Object} data - { name, code, icon }
   */
  create(data) {
    return apiRequest('/api/sales-platforms', {
      method: 'POST',
      body: data
    })
  },

  /**
   * 更新销售平台
   * @param {Object} data - { id, name, code, icon }
   */
  update(data) {
    return apiRequest('/api/sales-platforms', {
      method: 'PUT',
      body: data
    })
  },

  /**
   * 删除销售平台
   * @param {number} id
   */
  delete(id) {
    return apiRequest('/api/sales-platforms', {
      method: 'DELETE',
      body: { id }
    })
  }
}